import {
  provideSoftAppsModule,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { default as de } from '../i18n/de.json';
import { provideStorageLocationGlobals } from './storage-location.globals';
import { storageLocationRoutes } from './storage-location.routes';
import { getModuleGroupById } from '@softline/application';

export function provideStorageLocation() {
  return [
    provideSoftAppsModule(
      {
        icon: 'fa-regular fa-scanner-gun',
        name: 'mde/storage-location',
        route: 'storage-location/select',
        title: '#STORAGE_LOCATION.TITLE',
        permission: 'ROLE_LOCATIONASSIGNMENT_SERVICE',
        group: getModuleGroupById(6),
      },
      withSoftAppsModuleRoutes({ app: storageLocationRoutes }),
      withSoftAppsModuleTranslation({ de }),
      withSoftAppsModuleInfo({
        library: '@softapps/mde/storage-location',
        description: 'Lagerplätze mit dem MDE-Gerät auswählen und bearbeiten.',
      })
    ),
    ...provideStorageLocationGlobals(),
  ];
}
